export default {
  form: {
    should_save_payment_info: {
      label: 'Gem betalingsoplysninger til hurtigere betaling',
    },
  },
};
